import { ReactNode, ReactElement, isValidElement, cloneElement } from 'react';

export const cleanAddress = (address: ReactNode): ReactElement => {
    const addressWithExtendedProps =
        address && isValidElement(address)
            ? cloneElement(address, {
                  ...(address.props as any),
                  address: {
                      ...(address.props as any).address,
                      FullAddress: (address.props as any).address?.FullAddress?.replace('DEF', '')?.trim(),
                      State: (address.props as any).address?.State?.replace('DEF', '')?.trim()
                  },
                  value: (address.props as any)?.value?.replace('DEF', '')?.trim()
              })
            : address;
    return addressWithExtendedProps as ReactElement;
};
